/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminUpdateProductMarketplace
 */
export interface AdminUpdateProductMarketplace {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProductMarketplace
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProductMarketplace
     */
    link: string;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminUpdateProductMarketplace
     */
    name: AdminMarketplaceType;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProductMarketplace
     */
    price: number;
}



export function AdminUpdateProductMarketplaceFromJSON(json: any): AdminUpdateProductMarketplace {
    return AdminUpdateProductMarketplaceFromJSONTyped(json, false);
}

export function AdminUpdateProductMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateProductMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'link': json['link'],
        'name': AdminMarketplaceTypeFromJSON(json['name']),
        'price': json['price'],
    };
}

export function AdminUpdateProductMarketplaceToJSON(value?: AdminUpdateProductMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'link': value.link,
        'name': AdminMarketplaceTypeToJSON(value.name),
        'price': value.price,
    };
}

